import QuotingCoverage from '../../../icons/quoting coverage.svg';
import CompletingApplication from '../../../icons/completing application.svg';
import ApplicationReview from '../../../icons/application review.svg';
import PolicyDelivery from '../../../icons/policy delivery.svg';
import CoverageActive from '../../../icons/coverage active.svg';

const statuses = [
  {
    name: 'Quoting Coverage',
    iconSrc: QuotingCoverage,
    isActive: false,
    isInProgress: false,
    isComplete: false,
    isDisabled: false,
    step: 1,
    percent: 20
  },
  {
    name: 'Completing Application',
    iconSrc: CompletingApplication,
    isActive: false,
    isInProgress: false,
    isComplete: false,
    isDisabled: false,
    step: 2,
    percent: 40
  },
  {
    name: 'Application Review',
    iconSrc: ApplicationReview,
    isActive: false,
    isComplete: false,
    isDisabled: false,
    step: 3,
    percent: 60
  },
  {
    name: 'Policy Delivery',
    iconSrc: PolicyDelivery,
    isActive: false,
    isInProgress: false,
    isComplete: false,
    isDisabled: false,
    step: 4,
    percent: 80
  },
  {
    name: 'Coverage Active',
    iconSrc: CoverageActive,
    isActive: false,
    isInProgress: false,
    isComplete: false,
    isDisabled: false,
    step: 5,
    percent: 100
  },
  {
    name: 'Closed',
    iconSrc: ApplicationReview,
    isActive: false,
    isInProgress: false,
    isComplete: false,
    isDisabled: false,
    step: 0,
    percent: 0,
    display: false
  }
];

const configureStatusObject = (statuses, currentStatus) => {

  statuses.forEach((item, i) => {
    item.isActive = false;
    item.isDisabled = false;
    item.isInProgress = false;
    item.isComplete = false;
  });

  switch (currentStatus) {
    case 'Quoting Coverage':
      statuses[0].isActive = true;
      statuses[1].isDisabled = true;
      statuses[2].isDisabled = true;
      statuses[3].isDisabled = true;
      statuses[4].isDisabled = true;
      break;
    case 'Completing Application':
      statuses[0].isComplete = true;
      statuses[1].isActive = true;
      statuses[2].isDisabled = true;
      statuses[3].isDisabled = true;
      statuses[4].isDisabled = true;
      break;
    case 'Application Review':
      statuses[0].isComplete = true;
      statuses[1].isComplete = true;
      statuses[2].isActive = true;
      statuses[3].isDisabled = true;
      statuses[4].isDisabled = true;
      break;
    case 'Policy Delivery':
      statuses[0].isComplete = true;
      statuses[1].isComplete = true;
      statuses[2].isComplete = true;
      statuses[3].isActive = true;
      statuses[4].isDisabled = true;
      break;
    case 'Coverage Active':
    case 'Closed':
      statuses[0].isComplete = true;
      statuses[1].isComplete = true;
      statuses[2].isComplete = true;
      statuses[3].isComplete = true;
      statuses[4].isActive = true;
      break;
    default:
      break;
  }

  return statuses.filter(x => x.display !== false);
}

const getStatusProgress = (status) => {
  let statusItem = statuses.find(item => item.name === status);

  if (!statusItem) {
    return;
  }

  return statusItem.percent;
}

export { statuses, configureStatusObject, getStatusProgress };


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/status.js